import { required, minLength, minValue, maxLength } from 'react-admin';

export const validateCompany = [required()];

export const validateName = [required()];
export const validateMenuName = [maxLength(255)];

export const validateDescription = [minLength(25)];

export const validatePositionInMenu = [required(), minValue(0)];

export const validateSortOrder = [required(), minValue(0)];
